import network from './network';

export default {
  // 获取所有公司列表
  getAllCompany() {
    return network.get('/api/info/company');
  },
  // 通过公司获取部门
  getDepartmentListByCompanyId(companyId) {
    return network.get('/api/info/department', { companyId });
  },
  // 通过公司获取巡检事业部列表
  getInspectionDepartmentListByCompanyId(companyId) {
    return network.get('/api/info/inspection/department', { companyId });
  },
  getPosition() {
    return network.get('/api/info/position');
  },
  getUserList(params) {
    return network.get('/api/info/user', params);
  },
  // 获取审核表单中的公司列表
  // stationType: 0=全部，2=室分
  getInspectionCompany(stationType = 0) {
    return network.get('/api/info/company/inspection', { stationType });
  },
};
